<template>
  <div class="stepper stepper-pills" id="kt_stepper_password">
    <div class="stepper-nav flex-center flex-wrap mb-10">
      <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
        <div class="stepper-wrapper d-flex align-items-center">
          <div class="stepper-icon w-40px h-40px">
            <i class="stepper-check fas fa-check"></i>
            <span class="stepper-number">1</span>
          </div>
          <div class="stepper-label">
            <h3 class="stepper-title">Passo 1</h3>

            <div class="stepper-desc">Solicitação</div>
          </div>
        </div>
        <div class="stepper-line h-40px"></div>
      </div>
      <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
        <div class="stepper-wrapper d-flex align-items-center">
          <div class="stepper-icon w-40px h-40px">
            <i class="stepper-check fas fa-check"></i>
            <span class="stepper-number">2</span>
          </div>
          <div class="stepper-label">
            <h3 class="stepper-title">Passo 2</h3>
            <div class="stepper-desc">Validação</div>
          </div>
        </div>
        <div class="stepper-line h-40px"></div>
      </div>
      <div class="stepper-item mx-8 my-4" data-kt-stepper-element="nav">
        <div class="stepper-wrapper d-flex align-items-center">
          <div class="stepper-icon w-40px h-40px">
            <i class="stepper-check fas fa-check"></i>
            <span class="stepper-number">3</span>
          </div>
          <div class="stepper-label">
            <h3 class="stepper-title">Passo 3</h3>
            <div class="stepper-desc">Redefinição</div>
          </div>
        </div>
        <div class="stepper-line h-40px"></div>
      </div>
    </div>
    <div class="form w-lg-500px mx-auto" id="kt_stepper_form">
      <div
        class="col-12 w-xxl-500px w-xl-500px w-lg-500px p-1 p-sm-10 p-md-10 p-lg-10 p-xl-10 p-xxl-10"
        data-kt-stepper-element="content"
      >
        <div class="form w-100">
          <div class="text-center mb-10">
            <h1 class="text-dark mb-3">Esqueceu sua senha ?</h1>
            <div class="text-gray-400 fw-bold fs-4">
              Insira seu e-mail para redefinir sua senha.
            </div>
          </div>
          <div class="fv-row mb-10">
            <label class="form-label fs-6 fw-bolder text-dark">Email</label>
            <input
              @keydown.stop.prevent.enter="submitForgotPassword"
              id="txtEmail"
              class="form-control form-control-lg form-control-solid"
              type="text"
              v-model="this.email"
            />
          </div>
        </div>
      </div>
      <div
        class="col-12 w-xxl-500px w-xl-500px w-lg-500px p-1 p-sm-10 p-md-10 p-lg-10 p-xl-10 p-xxl-10"
        data-kt-stepper-element="content"
      >
        <div class="form w-100">
          <div class="text-center mb-10">
            <h1 class="text-dark mb-3">Já recebeu o código de validação ?</h1>
            <div class="text-gray-400 fw-bold fs-4">
              Insira o código enviado no seu e-mail para redefinir sua senha.
            </div>
          </div>
          <div class="fv-row mb-10">
            <label class="form-label fs-6 fw-bolder text-dark">Código</label>
            <input
              @keydown.stop.prevent.enter="submitCodigo"
              id="txtCodigo"
              class="form-control form-control-lg form-control-solid"
              type="text"
              v-model="this.codigoVerificacao"
            />
          </div>
        </div>
      </div>
      <div
        class="col-12 w-xxl-500px w-xl-500px w-lg-500px p-1 p-sm-10 p-md-10 p-lg-10 p-xl-10 p-xxl-10"
        data-kt-stepper-element="content"
      >
        <div class="form w-100">
          <div class="text-center mb-10">
            <h1 class="text-dark mb-3">Configurar nova senha</h1>
            <div class="text-gray-400 fw-bold fs-4">
              Você já redefiniu a senha?
              <router-link to="/sign-in" class="link-primary fw-bolder">
                Conecte-se aqui
              </router-link>
            </div>
          </div>
          <div class="mb-10 fv-row" id="kt_password_meter_control">
            <div class="mb-1">
              <label class="form-label fw-bolder text-dark fs-6"> Senha </label>
              <div class="position-relative mb-3">
                <input
                  @keydown.stop.prevent.enter="
                    this.nextFocus('txtConfirmarSenha')
                  "
                  id="txtSenha"
                  class="form-control form-control-lg form-control-solid"
                  type="password"
                  placeholder=""
                  autocomplete="off"
                  v-model="this.senha"
                />
              </div>
              <div
                class="d-flex align-items-center mb-3"
                data-kt-password-meter-control="highlight"
              >
                <div
                  class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"
                ></div>
                <div
                  class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"
                ></div>
                <div
                  class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"
                ></div>
                <div
                  class="flex-grow-1 bg-secondary bg-active-success rounded h-5px"
                ></div>
              </div>
            </div>
            <div class="text-muted">
              Use 8 ou mais caracteres alternando entre letras, números e
              símbolos.
            </div>
          </div>
          <div class="fv-row mb-10">
            <label class="form-label fw-bolder text-dark fs-6"
              >Confirme sua senha</label
            >
            <input
              @keydown.stop.prevent.enter="submitPassword"
              id="txtConfirmarSenha"
              class="form-control form-control-lg form-control-solid"
              type="password"
              placeholder=""
              autocomplete="off"
              v-model="this.confirmarSenha"
            />
          </div>
          <div class="d-flex justify-content-center fv-row mb-10">
            <vue-recaptcha
              v-show="exibirRecaptcha"
              :sitekey="this.keyReCaptcha"
              size="normal"
              theme="light"
              hl="pt-br"
              :loading-timeout="loadingTimeout"
              @verify="recaptchaVerified"
              @expire="recaptchaExpired"
              @fail="recaptchaFailed"
              @error="recaptchaError"
              ref="vueRecaptcha"
            >
            </vue-recaptcha>
          </div>
        </div>
      </div>
      <div class="d-flex flex-stack">
        <div class="me-2">
          <button
            type="button"
            class="btn btn-light btn-active-light-primary"
            data-kt-stepper-action="previous"
          >
            Voltar
          </button>
        </div>
        <div>
          <button
            @click="submitPassword"
            type="button"
            class="btn btn-primary"
            data-kt-stepper-action="submit"
            v-bind:data-kt-indicator="loading ? 'on' : 'off'"
          >
            <span class="indicator-label"> Redefinir </span>
            <span class="indicator-progress">
              Aguarde...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-kt-stepper-action="next"
            v-bind:data-kt-indicator="loading ? 'on' : 'off'"
          >
            <span class="indicator-label"> Continuar </span>
            <span class="indicator-progress">
              Aguarde...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { StepperComponent } from "@/assets/ts/components";
import { PasswordMeterComponent } from "@/assets/ts/components";
import vueRecaptcha from "vue3-recaptcha2";
import recaptchaConfig from "@/recaptcha.json";

export default {
  name: "password-reset",
  components: { vueRecaptcha },
  data: () => ({
    codeRecaptcha: "",
    loadingTimeout: 30000, // 30 seconds
    exibirRecaptcha: true,
    keyReCaptcha: recaptchaConfig.keyReCaptcha,
    subject: "",
    message: "",
    tagsEmails: [],
    files: [],
    email: "",
    codigoVerificacao: "",
    codigoGerado: {
      codigo: "",
      data: null,
    },
    senha: "",
    confirmarSenha: "",
    loading: false,
    options: {
      minLength: 8,
      checkUppercase: true,
      checkLowercase: true,
      checkDigit: true,
      checkChar: true,
      scoreHighlightClass: "active",
    },
    IPasswordMeterQueries: {
      componentName: "password-meter",
      instanseQuery: "[data-kt-password-meter]",
      inputQuery: "input[type]",
      visibilityQuery: '[data-kt-password-meter-control="visibility"]',
      highlightQuery: '[data-kt-password-meter-control="highlight"]',
    },
  }),
  async mounted() {
    this.codeRecaptcha = "";

    if (this.$route.query.email !== undefined) {
      this.email = this.$route.query.email;
    }

    var element = document.querySelector("#kt_stepper_password");
    var stepper = new StepperComponent(element);

    stepper.on("kt.stepper.next", async (event) => {
      if (stepper.currentStepIndex === 1) {
        await this.submitForgotPassword();
      } else if (stepper.currentStepIndex === 2) {
        await this.submitCodigo();
      }
    });

    stepper.on("kt.stepper.previous", function (event) {
      stepper.goPrev();
    });

    stepper.goto(2);
    stepper.goto(1);

    var passwordMeterElement = document.querySelector(
      "#kt_password_meter_control"
    );

    var passwordMeter = new PasswordMeterComponent(
      passwordMeterElement,
      this.options,
      this.IPasswordMeterQueries
    );

    passwordMeter.reset();

    setTimeout(() => {
      document.getElementById("txtEmail").focus();
    }, 400);
  },
  methods: {
    recaptchaVerified(response) {
      this.codeRecaptcha = response;
    },
    recaptchaExpired() {
      this.recaptchaReset();
    },
    recaptchaFailed() {
      this.codeRecaptcha = "";
    },
    recaptchaError(reason) {
      console.log(reason);
      this.codeRecaptcha = "";
    },
    recaptchaReset() {
      this.$refs.vueRecaptcha.reset();
      this.codeRecaptcha = "";
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async submitForgotPassword() {
      if ((await this.validarEmail()) === true) {
        this.loading = true;

        this.codigoGerado.codigo = this.$utils
          .getRandomIntInclusive(100000, 999999)
          .toString();
        this.codigoGerado.data = new Date();

        this.tagsEmails.push(this.email);
        this.subject = "Código de Verificação - Gateway Sistemas Web";
        this.message =
          '<h2 style="text-align:center">Gateway Sistemas</h2>' +
          '<span style=color:#777777><h1 style="text-align:center">Aqui está o código de verificação</h1></span>' +
          "<span style=color:#FFFFFF>" +
          '<div style="background:#212529;border:4px solid #E0E2EA;padding:20px 20px;width:75%;margin: auto;">' +
          '<p style="text-align:center"><span style="font-size:18px">Para concluir sua solicitação em Gateway Sistemas Web, insira o código no campo solicitado pela aplicação.</span></p>' +
          "<hr />" +
          '<p style="text-align:center"><span style="font-size:22px"><strong>' +
          this.codigoGerado.codigo +
          "</strong></span></p>" +
          "<hr />" +
          '<div style="page-break-after: always"><span style="display:none">&nbsp;</span></div>' +
          '<p><br><span style="font-size:14px">Não realizou nenhuma solicitação? Por favor ignore este e-mail. Obrigado.</span></p>' +
          "</div>" +
          '<p style="text-align:center"><br><img src=https://uploaddeimagens.com.br/images/003/404/848/original/Assinatura.png?1630279225 >';

        var email = {
          emails: this.tagsEmails,
          celular: "",
          titulo: this.subject,
          mensagem: this.message,
          anexos: this.files,
        };

        try {
          var response = await this.$store.dispatch(
            "compartilhamento/enviarEmail",
            email
          );
          if (response.Success === true) {
            await this.$swal.showSuccessAlert(
              "Email enviado com sucesso!",
              (alert) => {
                var element = document.querySelector("#kt_stepper_password");
                var stepper = StepperComponent.getInstance(element);
                stepper.goNext();
                this.$utils.requestFocus("txtCodigo");
              }
            );
          }
        } catch (error) {
          await this.$swal.showInvalidAlert("Não foi possível enviar o email!");
        }
        this.loading = false;
      }
    },
    async validarEmail() {
      let result = true;
      if (this.$utils.checkEmail(this.email) === true) {
        await this.$swal.showInvalidAlert(
          "O e-mail informado é inválido!",
          (alert) => {
            this.$utils.requestFocus("txtEmail");
            result = false;
          }
        );
      }
      return result;
    },
    async submitCodigo() {
      if (this.codigoGerado.codigo === this.codigoVerificacao) {
        var element = document.querySelector("#kt_stepper_password");
        var stepper = StepperComponent.getInstance(element);

        const dataExpiracao = new Date(this.codigoGerado.data);
        dataExpiracao.setMinutes(dataExpiracao.getMinutes() + 5);

        const dataAtual = new Date();

        if (dataAtual > dataExpiracao) {
          await this.$swal.showInvalidAlert(
            "O código expirou, por favor solicite um novo código!",
            (alert) => {
              this.codigoVerificacao = "";
              stepper.goPrev();
              this.$utils.requestFocus("txtEmail");
            }
          );
        } else {
          stepper.goNext();
          setTimeout(() => {
            document.getElementById("txtSenha").focus();
          }, 400);
        }
      } else {
        await this.$swal.showInvalidAlert(
          "Código de verificação inválido!",
          (alert) => {
            this.$utils.requestFocus("txtCodigo");
          }
        );
      }
    },
    async submitPassword() {
      if ((await this.validarSenha()) === true) {
        var loginViewModel = {
          Login: this.email,
          Password: this.senha,
          SessaoUsuario: {
            ResponseRecaptcha: this.codeRecaptcha,
          },
        };
        this.loading = true;
        try {
          var retPut = await this.$store.dispatch(
            "usuario/putRedefinirSenhaUsuario",
            loginViewModel
          );
          if (retPut.Success === true) {
            await this.$swal.showSuccessAlert(
              "Senha redefinida com sucesso!",
              (alert) => {
                this.$router.push("/sign-in");
              }
            );
          } else if (retPut.Success === false) {
            await this.$swal.showErrorAlert(retPut.Message, (alert) => {
              this.recaptchaReset();
            });
          }
        } catch (error) {
          await this.$swal.showInvalidAlert(
            "Não foi possível redefinir a senha!",
            (alert) => {
              this.recaptchaReset();
            }
          );
        }
        this.loading = false;
      }
    },
    async validarSenha() {
      let result = true;
      var passwordMeterElement = document.querySelector(
        "#kt_password_meter_control"
      );

      var passwordMeter =
        PasswordMeterComponent.getInstance(passwordMeterElement);

      var score = passwordMeter.getScore();

      if (this.senha === "") {
        await this.$swal.showInvalidAlert(
          "A senha informada não atende os requisitos!",
          (alert) => {
            this.$utils.requestFocus("txtSenha");
            result = false;
          }
        );
      }

      if (score < 60) {
        await this.$swal.showInvalidAlert(
          "A senha informada está muito fraca!",
          (alert) => {
            this.$utils.requestFocus("txtSenha");
            result = false;
          }
        );
      }

      if (this.senha != this.confirmarSenha) {
        await this.$swal.showInvalidAlert(
          "As senhas não conferem!",
          (alert) => {
            this.$utils.requestFocus("txtConfirmarSenha");
            result = false;
          }
        );
      }

      return result;
    },
  },
};
</script>
